export default __webpack_public_path__ + "scripts/resources/assignments/en/chem207/exp01/spectra.json";